import usePaginationFromEndpoint, {
    usePaginationFromEndpointProps,
} from "@/components/templates/PaginatedList/usePaginationFromEndpoint";
import { activitiesApi } from "@/shared/apis";
import { ActivitiesQueryParameters } from "@/shared/apis/activitiesApi";
import { RelatedActivitySortProperty, RelatedActivityType, SortOrder } from "@/shared/domain";

type useActitivitiesQueriesProps = {
    useActitivitiesPageQuery: () => usePaginationFromEndpointProps<MyBrokerApi.Activity, RelatedActivitySortProperty>;
};

export const useActitivitiesQueries = ({
    id,
    featureType,
    policyholderId,
}: {
    id: number | string;
    featureType: RelatedActivityType;
    policyholderId?: number;
}): useActitivitiesQueriesProps => {
    const endPoint = (request: ActivitiesQueryParameters) => activitiesApi.getActivities(id, featureType, request);
    const useActitivitiesPageQuery = () => {
        return usePaginationFromEndpoint<
            MyBrokerApi.Activity,
            MyBrokerApi.ActivityPayload,
            ActivitiesQueryParameters,
            RelatedActivitySortProperty
        >({
            id: id.toString(),
            objectType: "activity",
            defaultCategory: featureType,
            tableMode: true,
            endPoint,
            otherParams: { policyHolderId: policyholderId },
            defaultSorting: { property: "dueDate", order: SortOrder.Descending },
        });
    };

    return {
        useActitivitiesPageQuery,
    };
};
